import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

import Button from 'atomic/button/button';
import Link from 'atomic/link/link';
import Svg from 'atomic/svg/svg';
import login from 'assets/icons/login.svg';

import './cabinet.scss';

const Cabinet: React.FC<HTMLAttributes<HTMLElement>> = ({ className, ...props }) => {
    const cabinetClasses = classNames(className, 'cabinet');

    return (
        <div className={cabinetClasses} {...props}>
            <Link className="cabinet__register-link" wrapper={true} href="https://dolacz.opineo.pl/#dolacz-do-opineo">
                + Dołącz
            </Link>
            <Button className="cabinet__login-button" wrapper={true}>
                <Svg className="cabinet__login-icon" path={login} width={36} />
                <div className="cabinet__dropdown-list">
                    <a className="cabinet__dropdown-list-item" title="Zaloguj się jako firma" href="https://panel.opineo.pl/">
                        Zaloguj jako firma
                    </a>
                </div>
            </Button>
        </div>
    );
};

export default Cabinet;
